import User from "users/entities/user/user";

export default class DisableUserAPIRequest {
  userId: string;

  constructor(user: User) {
    if (!user.id) throw new Error("User must have an id to be disabled.");
    this.userId = user.id.value;
  }
}
